import { build } from './base'

export default build('#d9480f', '#1f1f1f')



// WEBPACK FOOTER //
// ./src/app/themes/dark.js